import Consumer, { Provider } from './Url';

export { Provider as UrlProvider };
export { default as withUrl } from './withUrl';

export default Consumer;
